export const sleepList: any = [
	{
		value: 5,
		name: 'Fantastic',
		description: 'I sleep really well!',
	},
	{
		value: 4,
		name: 'Very good',
		description: 'I sleep well most nights',
	},
	{
		value: 3,
		name: 'Okay',
		description: 'It’s a bit up and down',
	},
	{
		value: 2,
		name: 'Not great',
		description: 'I often feel tired',
	},
	{
		value: 1,
		name: 'Terrible',
		description: 'I barely sleep and feel exhausted',
	},
];

export const overallList: any = [
	{ name: 'Struggling – Things have been tough lately', value: 1 },
	{ name: 'Not great – It’s been hard to stay positive', value: 2 },
	{ name: 'Just okay – I’ve felt a bit off lately', value: 3 },
	{ name: 'Pretty good – Things have been going well', value: 4 },
	{ name: 'Great – I’ve been feeling really good!', value: 5 },
];
